import React from 'react';
import PropTypes from 'prop-types';
import { defaultTemplate } from 'core/hoc';
import {
    ApplicationEmptyState
} from 'core/components';
import {PreviewLayout} from 'core/layouts';
import { toDate } from 'core/utils';

function ImportPatientPreviewTemplate({ previewViewStore, t }) {
    const {
        item,
        loaderStore
    } = previewViewStore;

    const diagnosisCodes = item ? item.patientDetailDiagnosisCodes.map(item =>    
        <tr key={item.diagnosisCodeId}>
            <td><React.Fragment>{item.diagnosisCode.code}</React.Fragment></td>
            <td><React.Fragment>{item.diagnosisCode.name}</React.Fragment></td>
        </tr>
    ) : [];
    return (
        <PreviewLayout store={previewViewStore} emptyRenderer={<ApplicationEmptyState />} loading={loaderStore.loading}>
            <div className="row is-preview">
                <div className="col col-sml-12 col-lrg-8">
                    <div className="card card--form card--primary card--med u-mar--bottom--med">
                        <h4 className="form__title form__title--preview u-mar--bottom--med">
                        {item && <React.Fragment>Personal data</React.Fragment>}
                        </h4>
                        <div className="row u-mar--bottom--lrg">
                            <div className="col col-lrg-8">
                                <div className="u-separator--preview">
                                    <div className="row">
                                        <div className="col col-sml-12 col-lrg-6">
                                            <div className="form__group__label is-preview">{t('First name')}</div>
                                        </div>
                                        <div className="col col-sml-12 col-lrg-6">
                                            {item && <React.Fragment>{item.firstName}</React.Fragment>}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col col-lrg-8">
                                <div className="u-separator--preview">
                                    <div className="row">
                                        <div className="col col-sml-12 col-lrg-6">
                                            <div className="form__group__label is-preview">{t('Last name')}</div>
                                        </div>
                                        <div className="col col-sml-12 col-lrg-6">
                                            {item && <React.Fragment>{item.lastName}</React.Fragment>}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col col-lrg-8">
                                <div className="u-separator--preview">
                                    <div className="row">
                                        <div className="col col-sml-12 col-lrg-6">
                                            <div className="form__group__label is-preview">{t('Date of birth')}</div>
                                        </div>
                                        <div className="col col-sml-12 col-lrg-6">
                                            {item && <React.Fragment>{toDate(item.dateOfBirth)}</React.Fragment>}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col col-lrg-8">
                                <div className="u-separator--preview">
                                    <div className="row">
                                        <div className="col col-sml-12 col-lrg-6">
                                            <div className="form__group__label is-preview">{t('SSN')}</div>
                                        </div>
                                        <div className="col col-sml-12 col-lrg-6">
                                            {item && <React.Fragment>{item.ssn}</React.Fragment>}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <h4 className="form__title form__title--preview u-mar--bottom--med">
                        {item && <React.Fragment>Contact data</React.Fragment>}
                        </h4>
                        <div className="row u-mar--bottom--lrg">
                            <div className="col col-lrg-8">
                                <div className="u-separator--preview">
                                    <div className="row">
                                        <div className="col col-sml-12 col-lrg-6">
                                            <div className="form__group__label is-preview">{t('Relationship')}</div>
                                        </div>
                                        <div className="col col-sml-12 col-lrg-6">
                                            {item && <React.Fragment>{item.contactRelationship}</React.Fragment>}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col col-lrg-8">
                                <div className="u-separator--preview">
                                    <div className="row">
                                        <div className="col col-sml-12 col-lrg-6">
                                            <div className="form__group__label is-preview">{t('First name')}</div>
                                        </div>
                                        <div className="col col-sml-12 col-lrg-6">
                                            {item && <React.Fragment>{item.contactFirstName}</React.Fragment>}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col col-lrg-8">
                                <div className="u-separator--preview">
                                    <div className="row">
                                        <div className="col col-sml-12 col-lrg-6">
                                            <div className="form__group__label is-preview">{t('Last name')}</div>
                                        </div>
                                        <div className="col col-sml-12 col-lrg-6">
                                            {item && <React.Fragment>{item.contactLastName}</React.Fragment>}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col col-lrg-8">
                                <div className="u-separator--preview">
                                    <div className="row">
                                        <div className="col col-sml-12 col-lrg-6">
                                            <div className="form__group__label is-preview">{t('Address line 1')}</div>
                                        </div>
                                        <div className="col col-sml-12 col-lrg-6">
                                            {item && <React.Fragment>{item.contactAddressLine1}</React.Fragment>}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col col-lrg-8">
                                <div className="u-separator--preview">
                                    <div className="row">
                                        <div className="col col-sml-12 col-lrg-6">
                                            <div className="form__group__label is-preview">{t('Address line 2')}</div>
                                        </div>
                                        <div className="col col-sml-12 col-lrg-6">
                                            {item && <React.Fragment>{item.contactAddressLine2}</React.Fragment>}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col col-lrg-8">
                                <div className="u-separator--preview">
                                    <div className="row">
                                        <div className="col col-sml-12 col-lrg-6">
                                            <div className="form__group__label is-preview">{t('Country')}</div>
                                        </div>
                                        <div className="col col-sml-12 col-lrg-6">
                                            {item && <React.Fragment>{item.contactCountry}</React.Fragment>}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col col-lrg-8">
                                <div className="u-separator--preview">
                                    <div className="row">
                                        <div className="col col-sml-12 col-lrg-6">
                                            <div className="form__group__label is-preview">{t('State')}</div>
                                        </div>
                                        <div className="col col-sml-12 col-lrg-6">
                                            {item && <React.Fragment>{item.contactState}</React.Fragment>}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col col-lrg-8">
                                <div className="u-separator--preview">
                                    <div className="row">
                                        <div className="col col-sml-12 col-lrg-6">
                                            <div className="form__group__label is-preview">{t('Postal code')}</div>
                                        </div>
                                        <div className="col col-sml-12 col-lrg-6">
                                            {item && <React.Fragment>{item.contactPostalCode}</React.Fragment>}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col col-lrg-8">
                                <div className="u-separator--preview">
                                    <div className="row">
                                        <div className="col col-sml-12 col-lrg-6">
                                            <div className="form__group__label is-preview">{t('Phone')}</div>
                                        </div>
                                        <div className="col col-sml-12 col-lrg-6">
                                            {item && <React.Fragment>{item.contactPhone}</React.Fragment>}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <h4 className="form__title form__title--preview u-mar--bottom--med">
                        {item && <React.Fragment>Clinical data</React.Fragment>}
                        </h4>
                        <div className="row u-mar--bottom--lrg">
                            <div className="col col-lrg-8">
                                <div className="u-separator--preview">
                                    <div className="row">
                                        <div className="col col-sml-12 col-lrg-6">
                                            <div className="form__group__label is-preview">{t('Gender')}</div>
                                        </div>
                                        <div className="col col-sml-12 col-lrg-6">
                                            {item && <React.Fragment>{item.gender}</React.Fragment>}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col col-lrg-8">
                                <div className="u-separator--preview">
                                    <div className="row">
                                        <div className="col col-sml-12 col-lrg-6">
                                            <div className="form__group__label is-preview">{t('Height')}</div>
                                        </div>
                                        <div className="col col-sml-12 col-lrg-6">
                                            {item && <React.Fragment>{item.height}</React.Fragment>}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col col-lrg-8">
                                <div className="u-separator--preview">
                                    <div className="row">
                                        <div className="col col-sml-12 col-lrg-6">
                                            <div className="form__group__label is-preview">{t('Weight')}</div>
                                        </div>
                                        <div className="col col-sml-12 col-lrg-6">
                                            {item && <React.Fragment>{item.weight}</React.Fragment>}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col col-lrg-8">
                                <div className="u-separator--preview">
                                    <div className="row">
                                        <div className="col col-sml-12 col-lrg-6">
                                            <div className="form__group__label is-preview">{t('Ordering doctor')}</div>
                                        </div>
                                        <div className="col col-sml-12 col-lrg-6">
                                            {item && <React.Fragment>{item.orderingDoctor}</React.Fragment>}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col col-sml-12 col-lrg-12 u-mar--bottom--med">
                                <h4 className="form__title form__title--preview">Diagnosis codes</h4>
                                <div className="row">
                                    <div className="col col-sml-12 col-lrg-8">
                                        <table className="table--preview">
                                            <thead >
                                                <tr>
                                                    <th>Code</th>
                                                    <th>Description</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {diagnosisCodes}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        <h4 className="form__title form__title--preview u-mar--bottom--med">
                        {item && <React.Fragment>Primary insurance information</React.Fragment>}
                        </h4>
                        <div className="row u-mar--bottom--lrg">
                            <div className="col col-lrg-8">
                                <div className="u-separator--preview">
                                    <div className="row">
                                        <div className="col col-sml-12 col-lrg-6">
                                            <div className="form__group__label is-preview">{t('Insurance')}</div>
                                        </div>
                                        <div className="col col-sml-12 col-lrg-6">
                                            {item && <React.Fragment>{item.primaryInsuranceName}</React.Fragment>}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col col-lrg-8">
                                <div className="u-separator--preview">
                                    <div className="row">
                                        <div className="col col-sml-12 col-lrg-6">
                                            <div className="form__group__label is-preview">{t('Insurance policy number')}</div>
                                        </div>
                                        <div className="col col-sml-12 col-lrg-6">
                                            {item && <React.Fragment>{item.primaryInsurancePolicyNumber}</React.Fragment>}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col col-lrg-8">
                                <div className="u-separator--preview">
                                    <div className="row">
                                        <div className="col col-sml-12 col-lrg-6">
                                            <div className="form__group__label is-preview">{t('Start date')}</div>
                                        </div>
                                        <div className="col col-sml-12 col-lrg-6">
                                            {item && <React.Fragment>{toDate(item.primaryInsuranceStartDate)}</React.Fragment>}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <h4 className="form__title form__title--preview u-mar--bottom--med">
                        {item && <React.Fragment>Secondary insurance information</React.Fragment>}
                        </h4>
                        <div className="row u-mar--bottom--lrg">
                            <div className="col col-lrg-8">
                                <div className="u-separator--preview">
                                    <div className="row">
                                        <div className="col col-sml-12 col-lrg-6">
                                            <div className="form__group__label is-preview">{t('Insurance')}</div>
                                        </div>
                                        <div className="col col-sml-12 col-lrg-6">
                                            {item && <React.Fragment>{item.secondaryInsuranceName}</React.Fragment>}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col col-lrg-8">
                                <div className="u-separator--preview">
                                    <div className="row">
                                        <div className="col col-sml-12 col-lrg-6">
                                            <div className="form__group__label is-preview">{t('Insurance policy number')}</div>
                                        </div>
                                        <div className="col col-sml-12 col-lrg-6">
                                            {item && <React.Fragment>{item.secondaryInsurancePolicyNumber}</React.Fragment>}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col col-lrg-8">
                                <div className="u-separator--preview">
                                    <div className="row">
                                        <div className="col col-sml-12 col-lrg-6">
                                            <div className="form__group__label is-preview">{t('Start date')}</div>
                                        </div>
                                        <div className="col col-sml-12 col-lrg-6">
                                            {item && <React.Fragment>{toDate(item.secondaryInsuranceStartDate)}</React.Fragment>}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </PreviewLayout>
    )
}

ImportPatientPreviewTemplate.propTypes = {
    previewViewStore: PropTypes.object.isRequired,
    t: PropTypes.func
};

export default defaultTemplate(ImportPatientPreviewTemplate);
